// extracted by mini-css-extract-plugin
export var caption = "DoDontRow-module--caption--b338c";
export var card = "DoDontRow-module--card--4e39e";
export var cardContent = "DoDontRow-module--card-content--897a2";
export var cdsAssistiveText = "DoDontRow-module--cds--assistive-text--a5113";
export var cdsHideFeedback = "DoDontRow-module--cds--hide-feedback--2d31f";
export var cdsShowFeedback = "DoDontRow-module--cds--show-feedback--e3d34";
export var cdsSkeleton = "DoDontRow-module--cds--skeleton--4be8f";
export var cdsVisuallyHidden = "DoDontRow-module--cds--visually-hidden--aaf39";
export var content = "DoDontRow-module--content--65075";
export var correct = "DoDontRow-module--correct--d991a";
export var dark = "DoDontRow-module--dark--04e66";
export var description = "DoDontRow-module--description--edf89";
export var doDontRow = "DoDontRow-module--do-dont-row--5a703";
export var example = "DoDontRow-module--example--c7d71";
export var icon = "DoDontRow-module--icon--d7a7b";
export var iconCorrect = "DoDontRow-module--icon-correct--8fb97";
export var iconIncorrect = "DoDontRow-module--icon-incorrect--3801d";
export var image = "DoDontRow-module--image--de3a5";
export var incorrect = "DoDontRow-module--incorrect--b9bee";
export var ratio = "DoDontRow-module--ratio--2470a";
export var ratio16x9 = "DoDontRow-module--ratio16x9--5af3a";
export var ratio1x1 = "DoDontRow-module--ratio1x1--88113";
export var ratio1x2 = "DoDontRow-module--ratio1x2--3597e";
export var ratio2x1 = "DoDontRow-module--ratio2x1--cf4f5";
export var ratio3x4 = "DoDontRow-module--ratio3x4--c2ec3";
export var ratio4x3 = "DoDontRow-module--ratio4x3--c8ffa";
export var ratio9x16 = "DoDontRow-module--ratio9x16--efd8a";
export var text = "DoDontRow-module--text--40cbd";
export var title = "DoDontRow-module--title--5b09f";